// Module
var code = `<table class="table" ng-table="\$ctrl.locksTable">
  <thead>
    <tr>
      <th>#</th>
      <th>Type</th>
      <th>Status</th>
      <th>Created on</th>
      <th>Creation remarks</th>
      <th>Auto release on</th>
      <th>Released on</th>
    </tr>
  </thead>

  <tbody>
    <tr ng-repeat="item in \$data"
        ng-class="{'selected': \$ctrl.selectedLockId === item.id}">
      <td>{{ \$index+1 + (\$ctrl.locksTable.page() - 1) * \$ctrl.locksTable.count() }}</td>
      <td>{{ item.type | prettyEnum }}</td>
      <td>{{ item.released ? 'Released' : 'Active' }}</td>
      <td>{{ item.createdOn | prettyDate }}</td>
      <td>{{ item.creationRemarks }}</td>
      <td>{{ item.autoReleaseOn | prettyDate }}</td>
      <td>{{ item.releasedOn | prettyDate }}</td>
    </tr>
  </tbody>
</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/product-locks/product-locks.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;